
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

export default {
  props: {
    navigation: {
      type: Boolean,
      required: false,
      default: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    swiper: null,
  }),
  mounted() {
    this.loadSwiper();
  },
  methods: {
    loadSwiper() {
      this.swiper = new Swiper(this.$refs.swiper, {
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    },
  },
};
